import axios_nomura from './axios-nomura.services';

export const fetchRank = async (fundId) => {
  return await axios_nomura.get(`api/v1/funds/${fundId}/rank`, { params: { type: '1Y' } } );
};

export const fetchFundRank = async (data) => {
  return await axios_nomura.get(`api/v1/funds/${data.fundId}/rank`, { params: { type: data.type } });
};

export const fetchCategories = async () => {
  return await axios_nomura.get(`api/v1/category`);
};

export const fetchUserCategories = async () => {
  return await axios_nomura.get(`api/v1/category/favorite`);
};

export const saveUserCategories = async (data) => {
  return await axios_nomura.post(`api/v1/category/favorite`, data);
};
